import { z } from 'zod';

export const SUBDOMAIN_RE = /^[a-z0-9](?:[a-z0-9-]{1,28}[a-z0-9])?$/;

export const onboardingSchema = z.object({
  subdomain: z
    .string()
    .min(3, '3–30 characters')
    .max(30, '3–30 characters')
    .regex(SUBDOMAIN_RE, 'Lowercase letters, numbers, and single hyphens only'),
  template: z.enum(['minimal', 'dev-log', 'compass', 'batman', 'spiderman']),
  theme: z.enum(['ink', 'warm', 'cool', 'paper']),
  name: z.string().trim().min(2, 'Please add your name'),
  headline: z.string().max(140, 'Keep it under 140 characters').optional(),
  location: z.string().max(80).optional(),
});

export type OnboardingFormValues = z.infer<typeof onboardingSchema>;
